import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ChangePlan = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      d="M20 2v4.018C18.176 3.583 15.276 2 12 2 8.341 2 5.15 3.971 3.407 6.904l1.629 1.172A8.001 8.001 0 0 1 12 4c4.411 0 8 3.589 8 8V12.013l-.001.012h2v-.012L22 12V2h-2ZM12 20c-4.411 0-8-3.589-8-8H2v10h2v-4.019C5.824 20.417 8.724 22 12 22c3.635 0 6.807-1.945 8.558-4.846l-1.629-1.173C17.546 18.379 14.961 20 12 20Z"
      fill="currentColor"
    />
    <path
      d="M9.667 14.06c.008.01.782.954 2.1.954.863 0 1.42-.428 1.42-1.09 0-.644-.768-.88-1.658-1.15l-.004-.001c-1.29-.395-2.894-.886-2.894-2.876 0-1.331.978-2.411 2.444-2.711V5.9h1.916v1.3c1.379.31 2.062 1.145 2.09 1.18l.056.07-.06.062-1.266 1.337-.072-.086c-.006-.008-.646-.758-1.641-.758-.793 0-1.154.462-1.154.892 0 .645.768.88 1.659 1.15l.002.002c1.29.394 2.895.885 2.895 2.876 0 1.456-.96 2.559-2.51 2.894v1.299h-1.915v-1.254c-1.798-.29-2.714-1.441-2.753-1.491l-.054-.07 1.329-1.33.07.088Z"
      fill="currentColor"
    />
  </Icon>
));

export default ChangePlan;
